module.exports = __webpack_public_path__ + "76e385f15a2a5fc0e5b6a7051c0b0986.png";